import { createFileRoute } from "@tanstack/react-router";
import { PartnerShell } from "../../../features/partner/components/partner-shell";
import { PartnerAccountPage } from "../../../features/partner/pages/partner-account-page";

/** `/{lang}/partner/account`: who is signed in, language, sign out. */
export const Route = createFileRoute("/$lang/_partner/partner/account")({
  component: PartnerAccountRoute,
});

function PartnerAccountRoute() {
  const { lang } = Route.useParams();
  const search = Route.useSearch();
  return (
    <PartnerShell lang={lang} search={search} tab="account">
      <PartnerAccountPage />
    </PartnerShell>
  );
}
